/**
 * In-page storage for the Amplitude Browser SDK (2.x `Storage` shape:
 * `isEnabled` / `get` / `getRaw` / `set` / `remove` / `reset`, all async).
 *
 * The cookieless mode (see {@link amplitudeInitOptions}) hands this to the
 * SDK as its `storageProvider` — the queue of not-yet-sent events. The SDK's
 * default for that queue is `localStorage` even when `identityStorage` is
 * `'none'`, so without this the "no storage before consent" promise would
 * still write `AMP_unsent_*` to the device. Lives for one page load.
 */
export class AmplitudeMemoryStorage<T> {
  private readonly values = new Map<string, T>()

  isEnabled(): Promise<boolean> {
    return Promise.resolve(true)
  }

  get(key: string): Promise<T | undefined> {
    return Promise.resolve(this.values.get(key))
  }

  getRaw(key: string): Promise<string | undefined> {
    const value = this.values.get(key)
    return Promise.resolve(value === undefined ? undefined : JSON.stringify(value))
  }

  set(key: string, value: T): Promise<void> {
    this.values.set(key, value)
    return Promise.resolve()
  }

  remove(key: string): Promise<void> {
    this.values.delete(key)
    return Promise.resolve()
  }

  reset(): Promise<void> {
    this.values.clear()
    return Promise.resolve()
  }
}
